import { makeAutoObservable } from 'mobx';
import { parseVariableExpression } from '../utils/variableInput';

class PriceFetcherUpdateStore {
  data;

  refreshKey = 0

  ws = null;

  pid

  refreshPidKey = 0

  /**
   * 用戶自己填緊嘅變數（未撳「計算」）。撳掣先會 send 上 server —— 唔係嘅話打一個字就
   * 觸發一次 server 計算 + 一行 log。
   */
  draftVariables = {}

  /** 已經提交、server 而家計緊嗰組。 */
  submittedVariables = {}

  constructor() {
    makeAutoObservable(this);
  }

  setPid(pid) {
    this.pid = pid;
    this.refreshPidKey += 1;
  }

  setData(newData) {
    this.data = newData;
    this.refreshKey += 1;
  }

  setSocket(ws) {
    this.ws = ws;
    // 斷線重連之後，server 嗰邊係一條全新連線，唔會記得之前填過乜 —— 補送返。
    if (ws && Object.keys(this.submittedVariables).length) {
      this.sendVariables(this.submittedVariables);
    }
  }

  setDraftVariable(name, value) {
    this.draftVariables = { ...this.draftVariables, [name]: value };
  }

  setDraftVariables(values) {
    this.draftVariables = { ...values };
  }

  /**
   * 空白 = 未填（後端會出 0）。入嘅嘢可以係加數同帶千分位（`2,500,000+30,000`），
   * 所以要行返 `parseVariableExpression` 而唔係 `Number()` —— 後者見到逗號就 NaN。
   */
  submitVariables() {
    const cleaned = {};
    Object.entries(this.draftVariables).forEach(([name, value]) => {
      const n = parseVariableExpression(value);
      if (n === null) return;
      cleaned[name] = n;
    });
    this.submittedVariables = cleaned;
    this.sendVariables(cleaned);
    return cleaned;
  }

  sendVariables(variables) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    this.ws.send(JSON.stringify({ type: 'variables', variables }));
  }

  setConnected(status) {
    this.connected = status;
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
      this.connected = false;
    }
  }
}

// Create an instance of the store
const priceFetcherUpdateStore = new PriceFetcherUpdateStore();
export default priceFetcherUpdateStore;
